import { render, staticRenderFns } from "./ServiceItemList.vue?vue&type=template&id=19d21544"
import script from "./ServiceItemList.vue?vue&type=script&lang=js"
export * from "./ServiceItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports